import { Box, Heading } from '@chakra-ui/react';
import { FC } from 'react';

import { ThinEventSession } from '@/resources/ThinEventSession';

import { SessionTooltipLecturesList } from './SessionTooltipLecturesList';

export interface ISessionTooltipProps {
  title: string;
  session: ThinEventSession;
}

export const SessionTooltip: FC<ISessionTooltipProps> = ({ title, session }) => {
  return (
    <Box py="3" px="4" maxH="96" maxW={{ sm: '320px', md: '700px' }} overflowY="auto" cursor="pointer">
      <Heading as="h3" pb={2} fontSize="lg" fontWeight={'bold'}>
        {title}
      </Heading>
      <SessionTooltipLecturesList sessionId={session.id} />
    </Box>
  );
};
